<template>
  <FormGroupHorizontal 
    :label="$t('engine.manageText.modalWidget.lblStyle', languageEngine)"
    :contentClass="'position-static'"
    :split="'3:9'"
    :paddingClosest="'8'"
  >
    <FontTemplate
      :fontStyle="value"
      :isCustom="isCustom"
      :options="options"
      :menuMaxWidth="'auto'"
      :menuMaxHeight="'300px'"
      :menuDrop="'left'"
      @change="onChange"
    />
  </FormGroupHorizontal>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import FontTemplate from "@components_system/Shared/Tools/FontTemplate/FontTemplate";

export default {
  components: {
    FormGroupHorizontal,
    FontTemplate,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormat() {
      return this.texteditor.selectionFormat;
    },
    selectionFormatTemplate() {
      return this.texteditor.selectionFormatTemplate;
    },
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    options () {
      let _options = {}
      Object.entries(this.texteditor.templateFormats).forEach(([fontName, fontData]) => {
        let fontSize = fontData.size.replace('px', '')
        _options[fontName] = {...fontData, size: fontSize}
      });
      return _options
    },
    value() {
      return this.selectionFormat.template || this.selectionFormat.font || this.selectionFormat.fontOld || this.formatHeaderToFont(this.selectionFormat.header);
    },
    isCustom() {
      return Boolean(Object.keys(this.customFormats).length);
    },
    customFormats() {
      let customs = {};
      if (this.selectionFormat.family !== undefined) customs.family = this.selectionFormat.family;
      if (this.selectionFormat.size !== undefined) customs.size = this.selectionFormat.size;
      if (this.selectionFormat.bold !== undefined) customs.bold = this.selectionFormat.bold;
      if (this.selectionFormat.italic !== undefined) customs.italic = this.selectionFormat.italic;
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration')) {
        if (this.selectionFormat.underline !== undefined) customs.underline = this.selectionFormat.underline;
      }
      if (this.selectionFormat.fontWeight !== undefined) customs.fontWeight = this.selectionFormat.fontWeight;
      if (this.selectionFormat.fontStyle !== undefined) customs.fontStyle = this.selectionFormat.fontStyle;
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration')) {
        if (this.selectionFormat.decoration !== undefined) customs.decoration = this.selectionFormat.decoration;
      }
      if (this.selectionFormat.color !== undefined) customs.color = this.selectionFormat.color;
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'align')) {
        if (this.selectionFormat.align !== undefined) customs.align = this.selectionFormat.align;
      }
      return customs;
    },
  },
  methods: {
    formatHeaderToFont(value) {
      if (!value) return 'paragraph1';
      return `heading${value}`;
    },
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      let formatLine = {
        header: false,
        template: false,
        font: false,
        lineSize: false,
        lineHeight: false,
        lineColor: false,
        lineFontFamily: false,
        listItemColor: false,
        listItemFontFamily: false,
      };
      let formatText = {
        fontOld: false,
        family: false,
        size: false,
        sizeAttribute: false,
        bold: false,
        fontWeight: false,
        italic: false,
        fontStyle: false,
        underline: false,
        decoration: false,
        lineHeight: false,
        color: false,
        background: false,
      };

      if (Object.prototype.hasOwnProperty.call(this.texteditor.templateFormats, value)) {
        if (Object.prototype.hasOwnProperty.call(this.texteditor.templateFormats[value], 'align')) {
          formatLine.align = false
        }
      }

      if (value == "heading1") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 1; 
        formatLine.template = 'heading1'; 
      } else if (value == "heading2") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 2; 
        formatLine.template = 'heading2'; 
      } else if (value == "heading3") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 3; 
        formatLine.template = 'heading3'; 
      } else if (value == "heading4") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 4; 
        formatLine.template = 'heading4'; 
      } else if (Object.prototype.hasOwnProperty.call(this.texteditor.templateFormats, value)) {
        formatLine.header = false;
        formatLine.template = value; 
      } else { 
        formatLine.header = false; // use default
        formatLine.template = value; 
      } 

      // For clear cursor format 
      if (selection.index == 0 && selection.length == 0 && (
        this.selectionFormat.fontOld !== undefined ||
        this.selectionFormat.family !== undefined ||
        this.selectionFormat.size !== undefined ||
        this.selectionFormat.sizeAttribute !== undefined ||
        this.selectionFormat.bold !== undefined ||
        this.selectionFormat.fontWeight !== undefined ||
        this.selectionFormat.italic !== undefined ||
        this.selectionFormat.fontStyle !== undefined ||
        this.selectionFormat.underline !== undefined ||
        this.selectionFormat.decoration !== undefined ||
        this.selectionFormat.lineHeight !== undefined ||
        this.selectionFormat.color !== undefined ||
        this.selectionFormat.background !== undefined
      )) { 
        this.texteditor.editor.setContents([{ insert: '\n' }]);
      }

      // For Current
      this.texteditor.editor.formatLine(selection, formatLine);
      this.texteditor.editor.formatText(selection, formatText);

      // For Last LineBlank
      this.texteditor.editor.formatLine({index: selection.index + selection.length, length: 0}, formatLine);
      this.texteditor.editor.formatText({index: selection.index + selection.length, length: 0}, formatText);
    },
  },
}
</script>
